import { onTransitionEnd } from '../assets/utils';

const SET_TEXT = Symbol('set_loading_spinner_text');
const COUNT = Symbol('loading_spinner_count');
const SPINNER = Symbol('loading_spinner');
class Loader {

    show(text, element) {
        element = element || document.body;
        const spinner = this.getSpinner(element);
        spinner[SET_TEXT](text);
        if (spinner[COUNT] === 0) {
            element.appendChild(spinner);
            setTimeout(() => spinner.classList.remove('opacity-0'));
        }
        spinner[COUNT]++;
    }

    hide(element) {
        const spinner = this.getSpinner(element || document.body);
        spinner[COUNT]--;
        if (spinner[COUNT] <= 0) {
            spinner[COUNT] = 0;
            spinner.classList.add('opacity-0');
            onTransitionEnd(spinner, 500)
                .then(() => spinner.remove());
        }
    }

    getSpinner(element) {
        if (!element[SPINNER]) {
            const spinner = document.createElement('div');
            spinner.classList.add('fixed', 'z-20', 'top-0', 'left-0', 'w-full', 'h-full', 'bg-black', 'bg-opacity-50', 'transition-opacity', 'opacity-0', 'grid', 'place-items-center', 'text-white')

            const spinner_icon = document.createElement('div');
            spinner_icon.innerHTML = '<span class="fa fa-spinner fa-spin fa-2x"></span>';
            spinner_icon.classList.add('text-center');

            const text_element = document.createElement('div')

            const inner_wrapper = document.createElement('div');
            inner_wrapper.classList.add('grid', 'grid-cols-1', 'gap-6');

            inner_wrapper.appendChild(spinner_icon);
            inner_wrapper.appendChild(text_element);

            spinner.appendChild(inner_wrapper);

            spinner[SET_TEXT] = function (text) {
                text_element.innerText = text || '';
                if (text) {
                    text_element.classList.remove('hidden');
                } else {
                    text_element.classList.add('hidden');
                }
            }
            spinner[COUNT] = 0;
            element[SPINNER] = spinner;
        }
        return element[SPINNER];
    }
}

export default new Loader();